import React, { useState } from 'react';
// @ts-ignore
import styles from './DASTAListItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';

interface Props {
	item: {
		id: string;
		name: string;
		date: string;
		workplace: string;
		diagnosis: string;
		link: string;
	};
}

const DASTAListItem: React.FC<Props> = ({ item }) => {
	const [mediaViewerOpened, setMediaViewerOpened] = useState(false);

	const fileToViewer = {
		id: item.id,
		name: item.name,
		displayName: item.name,
		type: 'pdf',
		preview: item.link,
		download: item.link,
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.date}>
				<FormattedMomentDate date={item.date} format={DateFormat.DATE_TIME} />
			</div>
			<div className={styles.content}>
				{item.name && (
					<div className={styles.item}>
						<Text
							tx='component.DASTAListItem.name'
							firstUpper
							className={styles.title}
							colon
						/>
						<div className={styles.text}>{item.name}</div>
					</div>
				)}
				{item.workplace && (
					<div className={styles.item}>
						<Text
							tx='component.DASTAListItem.workplace'
							firstUpper
							className={styles.title}
							colon
						/>
						<div className={styles.text}>{item.workplace}</div>
					</div>
				)}
				{item.diagnosis && (
					<div className={styles.item}>
						<Text
							tx='component.DASTAListItem.diagnosis'
							firstUpper
							className={styles.title}
							colon
						/>
						<div className={styles.text}>{item.diagnosis}</div>
					</div>
				)}
			</div>
			<div className={styles.controls}>
				<LinkButton
					title={'component.DASTAListItem.PDFButton'}
					theme={Theme.BLUE}
					onClick={() => setMediaViewerOpened(true)}
				/>
			</div>
			{mediaViewerOpened && (
				<MediaViewerModal
					opened
					onClose={() => setMediaViewerOpened(false)}
					file={fileToViewer}
				/>
			)}
		</div>
	);
};

export default DASTAListItem;
